import { Link as TLink } from '@tonic-one/react';
import { handleLinkClick } from '@Utils/common';
export default ({ href, children, ...rest }: any) => {
  return (
    <TLink onClick={handleLinkClick} href={href} {...rest}>
      {children}
    </TLink>
  );
};
